<template>
  <div class="skeleton-section">
    <UiSkeleton
      :items="4"
      class-name="skeleton-section__item"
      class="skeleton-section__wrapper"
      :error="error"
    />
  </div>
</template>

<script>
export default {
  name: 'SkeletonNavSections',
  props: {
    error: { type: [Object, Boolean, Error] },
  },
}
</script>

<style lang="scss" scoped>
.skeleton-section {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;

  &__wrapper {
    display: flex;
    gap: var(--spaces-xs);
    overflow: hidden;
    padding: 0 var(--padding-xs);

    @include media(tablet) {
      gap: var(--spaces-l);
      padding: 0 var(--padding-m);
    }
  }

  ::v-deep &__item {
    width: 180px;
    height: 76px;
    border-radius: var(--radius-m);
    flex-shrink: 0;

    @include media(tablet-album) {
      width: 348px;
      height: 114px;
      border-radius: var(--radius-l);
    }
  }
}

</style>
